export enum PanoramaTransactions {
  ADD_MESSAGE = 'add-message',
  WIDGET_LOAD_VIEWER = 'widget-load-viewer',
  WIDGET_LOAD_EDITOR = 'widget-load-editor',
}
